export default __webpack_public_path__ + "static/media/ct_map.9717da57.png";